import { ShieldCheck, Landmark, Lock, FileCheck, Waves } from "lucide-react";

const ITEMS = [
  { icon: Landmark, label: "Garanti BBVA", testid: "marquee-item-garanti" },
  { icon: Landmark, label: "Türkiye İş Bankası", testid: "marquee-item-isbank" },
  { icon: Landmark, label: "Akbank", testid: "marquee-item-akbank" },
  { icon: Landmark, label: "Yapı Kredi", testid: "marquee-item-yapikredi" },
  { icon: Landmark, label: "QNB Finansbank", testid: "marquee-item-qnb" },
  { icon: Landmark, label: "Ziraat Bankası", testid: "marquee-item-ziraat" },
  { icon: ShieldCheck, label: "KVKK Uyumlu", testid: "marquee-badge-kvkk" },
  { icon: Lock, label: "256-bit SSL Şifreleme", testid: "marquee-badge-ssl" },
  { icon: FileCheck, label: "E-Fatura Entegre", testid: "marquee-badge-efatura" },
  { icon: Waves, label: "Açık Bankacılık", testid: "marquee-badge-openbanking" },
];

const Marquee = () => (
  <section
    data-testid="editorial-marquee"
    className="relative overflow-hidden border-y border-white/8 bg-[#0A0D14] py-6"
  >
    <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-32 bg-gradient-to-r from-[#07090E] to-transparent" />
    <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-32 bg-gradient-to-l from-[#07090E] to-transparent" />
    <div className="animate-marquee flex w-max items-center gap-14">
      {[...ITEMS, ...ITEMS].map((item, i) => (
        <span
          key={`${item.testid}-${i}`}
          data-testid={i < ITEMS.length ? item.testid : undefined}
          className="flex items-center gap-3 text-sm font-medium uppercase tracking-[0.22em] text-slate-500 transition-colors duration-300 hover:text-emerald-400"
        >
          <item.icon className="h-4 w-4 text-emerald-500/70" />
          {item.label}
        </span>
      ))}
    </div>
  </section>
);

export default Marquee;
